import { createSelector } from 'reselect'
import { excludeNullOrUndefined } from 'checkout/utils'
import getAllBreakdownViews from './getAllBreakdownViews'
import {
  getFlightsDateChangeBreakdownView,
  getIsCurrentFlightDateChangeSelectionValid,
} from './flights'

const getSummaryBreakdownViews = createSelector(
  (state: App.State) => getAllBreakdownViews(state),
  (state: App.State) => getFlightsDateChangeBreakdownView(state),
  (state: App.State) => state.checkout.cart.mode,
  (state: App.State) => getIsCurrentFlightDateChangeSelectionValid(state),
  (
    allBreakdownViews,
    flightsDateChangeBreakdown,
    checkoutMode,
    isCurrentFlightDateChangeSelectionValid,
  ): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    if (checkoutMode === 'flight-change-dates' && !isCurrentFlightDateChangeSelectionValid) {
      return {
        hasRequiredData: flightsDateChangeBreakdown.hasRequiredData,
        data: flightsDateChangeBreakdown.data.filter(excludeNullOrUndefined),
      }
    }

    return allBreakdownViews
  },
)

export default getSummaryBreakdownViews
